import { Eye, Home } from "lucide-react";
import { buildPortalTiles } from "@/pages/portal/portalTiles";
import { TONE_BG } from "@/constants/tones";

/** Mini-aperçu de l'accueil portail tel que le client le verra (calculé sur le brouillon, avant enregistrement). */
export default function PortalTilesPreview({ permissions, firstName, memberLabel }) {
  const tiles = buildPortalTiles({ portalPermissions: permissions });
  const proprio = !!permissions?.immeuble && !permissions?.t777;
  return (
    <div
      className={`mt-4 rounded-xl border border-dashed border-slate-300 p-3 bg-gradient-to-br ${proprio ? "from-emerald-50/50" : "from-blue-50/50"} via-white to-white`}
      data-testid="masters-perms-preview"
    >
      <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
        <div className="text-[11px] font-semibold text-slate-600 inline-flex items-center gap-1.5">
          <Eye className="w-3.5 h-3.5" /> Aperçu du portail · {memberLabel}
        </div>
        <div className="text-[10px] text-slate-400" data-testid="masters-perms-preview-count">
          {tiles.length} tuile(s) visible(s) — tel que vu par le client après « Enregistrer et Appliquer »
        </div>
      </div>
      <div className="text-base font-bold text-gray-900 mb-2">Bonjour {firstName || "…"}</div>
      {tiles.length === 0 ? (
        <div className="bg-white rounded-lg border border-slate-200 p-4 text-center" data-testid="masters-perms-preview-empty">
          <Home className="w-4 h-4 mx-auto text-slate-300 mb-1" />
          <p className="text-[11px] text-slate-500">Votre portail n'est pas encore configuré. Contactez votre conseiller pour activer les services.</p>
        </div>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-1.5">
          {tiles.map((t) => (
            <div
              key={t.id}
              className={`bg-gradient-to-br ${TONE_BG[t.tone]} rounded-lg border p-2 flex flex-col items-center text-center`}
              data-testid={`masters-perms-preview-tile-${t.id}`}
            >
              <div className="w-7 h-7 rounded-lg bg-white shadow-sm flex items-center justify-center mb-1">
                <t.icon className="w-4 h-4" />
              </div>
              <span className="text-[10px] font-semibold leading-tight">{t.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
